import type { AxiosInstance } from 'axios';
import type { EntityId, AssetListResponse, Asset } from '@/types';

export const getDocumentAssets = async (
  api: AxiosInstance,
  document_id: EntityId,
): Promise<AssetListResponse> => {
  const resp = await api.get(`/document/${document_id}/asset`);
  return resp.data;
};

export const getDocumentAsset = async (
  api: AxiosInstance,
  document_id: EntityId,
  asset_id: EntityId,
): Promise<Asset> => {
  const resp = await api.get(`/document/${document_id}/asset/${asset_id}`);
  return resp.data;
};

